export default {
  width: 26,
  height: 27,
  svg: `
    <path fill-rule="evenodd" d="M3.502 23.625h7.413A9.025 9.025 0 0 0 13.319 27H3.502a3.38 3.38 0 0 1-3.375-3.375V3.375A3.38 3.38 0 0 1 3.502 0h13.5a3.38 3.38 0 0 1 3.375 3.375v7.953a9.059 9.059 0 0 0-1.125-.078c-.381 0-.756.031-1.125.078V4.5c0-.621-.504-1.125-1.125-1.125h-13.5c-.621 0-1.125.504-1.125 1.125v18c0 .621.504 1.125 1.125 1.125ZM26 20.25A6.75 6.75 0 0 1 19.25 27a6.75 6.75 0 1 1 0-13.5A6.75 6.75 0 0 1 26 20.25Zm-5.625-1.125V15.75h-2.25v5.625h5.625v-2.25h-3.375Z" clip-rule="evenodd"/>
  `
}
